import { memoizeReduxStateForMultipleIds } from '@range.io/functional'
import memoizeResult from '../../memoize-result.js'
import { _field } from '../../selector-primitives.js'

const uploadsAsArray = memoizeResult(state => Object.values(state.uploads))

const _uploadsForCollaborationId = (state, id) => Object.values(state.uploads).filter(u => u.collaborationId === id)
const uploadsForCollaborationId = memoizeReduxStateForMultipleIds(['uploads'], _uploadsForCollaborationId)

// return correlated uploads for the upload
const correlatedUploads = (state, upload) => {
    const uploadsLookup = state.uploads
    return Object.values(uploadsLookup)
        .filter(el => el.correlationId === upload.correlationId)
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
}

// ---------------------------------------------------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------------------------------------------------

const UploadSelectors = {
    correlatedUploads,
    uploadsAsPOJO: _field('uploads'),
    uploadsAsArray,
    uploadsForCollaborationId,
}

export default UploadSelectors
